// extracted by mini-css-extract-plugin
module.exports = {"form":"form--FjWr1","content":"content--5NC8M","footer":"footer--YMOp5"};